
export const MAP_AD_REFRESH = 'MAP_AD_REFRESH';

export type MapAdRefreshActionType = {
    type: typeof MAP_AD_REFRESH;
    payload: string;
}

export function mapAdRefreshAction(userAction: string): MapAdRefreshActionType {
    return {
        type: MAP_AD_REFRESH,
        payload: userAction
    };
}
